import React, {Component} from 'react';

import { asModal, closeModal } from '../layouts/OldModal';
import Button from '../forms/Button';

const defaultProps = {
  onCancel() {},
  onConfirm() {},
};

class Confirmation extends Component {
  get cancel_label() {
    return this.props.cancelLabel || 'No';
  }

  get confirm_label() {
    return this.props.confirmLabel || 'Yes';
  }

  cancel = () => {
    this.props.onCancel();
    closeModal();
  };

  confirm = () => {
    this.props.onConfirm();
  };

  render() {
    return (
      <div className="ds-card">
        <div className="cardSection _withColumns _justifyContent-space-between">
          <div className="text _marginBottom--small-mobileOnly">
            <p className="copy">{this.props.children}</p>
          </div>

          <div className="_displayFlex">
            <Button
              label={this.confirm_label}
              onClick={this.confirm}
              className="-secondary _marginRight--small"
              data-testid="confirmation-yes-button"
            />

            <Button
              label={this.cancel_label}
              onClick={this.cancel}
              className="-danger"
              data-testid="confirmation-no-button"
            />
          </div>
        </div>
      </div>
    );
  }
}

Confirmation.defaultProps = defaultProps;

Confirmation = asModal(Confirmation, {
  windowClassName: '-small remove-supporting-document',
});

export default Confirmation;



// WEBPACK FOOTER //
// ./src/features/shared/components/notices/Confirmation.js